// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"3700005a","302":"d3a2a988","920":"1477388e","953":"98453030"}[chunkId] + ".chunk.js";
};